/* PrismJS Syntax Highlighting for Ghost */
(function () {
    const content = document.querySelector('.gh-content');
    if (!content) return;

    // Add markdown-body class for styling
    content.classList.add('markdown-body');

    // Language alias mapping for PrismJS
    const langMap = {
        'js': 'javascript',
        'ts': 'typescript', 
        'sh': 'bash',
        'shell': 'bash',
        'html': 'markup',
        'xml': 'markup',
        'py': 'python',
        'yml': 'yaml'
    };
    
    // Apply correct language classes to code blocks
    content.querySelectorAll('pre code').forEach(function(block) {
        var classes = block.className.split(' ');
        var lang = '';
        
        // Check for existing language class
        for (var i = 0; i < classes.length; i++) {
            var match = classes[i].match(/^(?:language-|lang-)(.+)$/);
            if (match) {
                lang = match[1];
                break;
            }
        }
        
        // Apply mapped language
        if (lang) {
            lang = langMap[lang] || lang;
            block.className = 'language-' + lang;
            if (block.parentElement) {
                block.parentElement.className = 'language-' + lang;
            }
        }
    });
    
    // Run Prism highlighting
    if (typeof Prism !== 'undefined') {
        Prism.highlightAllUnder(content);
    }
    
    // Also call global init if available
    if (typeof window.initPrismHighlighting === 'function') {
        window.initPrismHighlighting();
    }

    // Add copy buttons to code blocks
    content.querySelectorAll('pre').forEach(pre => {
        if (pre.parentElement && pre.parentElement.classList.contains('pre-wrapper')) return;
        
        // Create wrapper to hold pre and button
        const wrapper = document.createElement('div');
        wrapper.className = 'pre-wrapper';
        pre.parentNode.insertBefore(wrapper, pre);
        wrapper.appendChild(pre);
        
        const btn = document.createElement('button');
        btn.className = 'copy-btn';
        btn.innerHTML = '<svg viewBox="0 0 16 16" width="16" height="16"><path fill="currentColor" d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z"></path><path fill="currentColor" d="M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"></path></svg>';
        btn.title = 'Copy code';
        
        btn.addEventListener('click', async () => {
            const code = pre.querySelector('code');
            const text = code ? code.textContent : pre.textContent;
            
            try {
                await navigator.clipboard.writeText(text);
                btn.innerHTML = '<svg viewBox="0 0 16 16" width="16" height="16"><path fill="#22c55e" d="M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.75.75 0 0 1 1.06-1.06L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0Z"></path></svg>';
                setTimeout(() => {
                    btn.innerHTML = '<svg viewBox="0 0 16 16" width="16" height="16"><path fill="currentColor" d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0v1.5A1.75 1.75 0 0 1 9.25 16h-7.5A1.75 1.75 0 0 1 0 14.25Z"></path><path fill="currentColor" d="M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0 1 14.25 11h-7.5A1.75 1.75 0 0 1 5 9.25Zm1.75-.25a.25.25 0 0 0-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 0 0 .25-.25v-7.5a.25.25 0 0 0-.25-.25Z"></path></svg>';
                }, 2000);
            } catch (err) {
                console.error('Copy failed:', err);
            }
        });
        
        wrapper.appendChild(btn);
    });
})();

/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    if (!navigation) return;
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    if (typeof lightbox !== 'undefined') {
        lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img');
    }
})();

/* Responsive video in post content */
(function () {
    if (typeof reframe === 'undefined') return;
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    if (typeof dropdown !== 'undefined') {
        dropdown();
    }
})();

/* Infinite scroll pagination */
(function () {
    if (typeof pagination !== 'undefined') {
        if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
            pagination();
        }
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'table-wrapper';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
